import { metadata } from "./metadata.js";
import component from "@/blocks/layout/container/index.vue";

export default { metadata, component };
